import React from 'react';

import AnthropicSvg from '~/svg/Anthropic.svg';
import DeepseekSvg from '~/svg/deepseek.svg';
import GoogleSvg from '~/svg/google.svg';
import HailuoSvg from '~/svg/Hailuo.svg';
import MoonshotSvg from '~/svg/moonshot.svg';
import OpenAISvg from '~/svg/OpenAI.svg';
import PerplexitySvg from '~/svg/perplexity.svg';
import QwenSvg from '~/svg/qwen.svg';
import XaiSvg from '~/svg/xai.svg';

type Logo = {
  name: string;
  viewBox?: string;
  path?: string;
  Icon?: React.ComponentType<React.SVGProps<SVGSVGElement>>;
};

// Provider marks shown in the hero marquee (same set as the legacy
// HeroSection, which stays in use on special-offer / ai-workshops).
export const MODEL_LOGOS: Logo[] = [
  { name: 'Claude', Icon: AnthropicSvg },
  { name: 'OpenAI', Icon: OpenAISvg },
  { name: 'Gemini', Icon: GoogleSvg },
  {
    name: 'Nano Banana Pro',
    viewBox: '0 0 340 340',
    path: 'M0 170C0 76.3 76.3 0 170 0c37.8 0 73.7 12.2 103.7 35.2l-39.5 51.3c-18.6-14.3-40.8-21.8-64.2-21.8-58.1 0-105.3 47.2-105.3 105.3S111.9 275.3 170 275.3c46.8 0 86.4-30.7 100.2-72.9H170v-64.7h170V170c0 93.7-76.3 170-170 170S0 263.7 0 170',
  },
  {
    name: 'Seedance',
    viewBox: '0 0 32 32',
    path: 'M5.915 25.44 1 26.702V4.311l4.915 1.263zm23.75 1.31-4.924 1.264V3l4.924 1.254zm-15.952-.627-4.915 1.264v-13.19l4.915 1.263zm3.21-13.883 4.925-1.264v13.19l-4.924-1.264z',
  },
  {
    name: 'ElevenLabs',
    viewBox: '0 0 24 24',
    path: 'M2 0h6v24H2zM16 0h6v24h-6z',
  },
  {
    name: 'Runway',
    viewBox: '0 0 24 24',
    path: 'M20.678 14.063 17.99 11.38c5.666-.768 5.122-9.298-.61-9.298-2.358-.003-8.2.003-10.628 0-1.611-.018-3.192.878-4.011 2.266a4.7 4.7 0 0 0-.661 2.396c0 2.33.003 8.208 0 10.615-.005 5.726 8.526 6.262 9.31.616 1.55 1.437 3.572 4.27 5.99 4.05h-.002c4.038.123 6.254-5.183 3.3-7.96ZM8.594 17.36c.036 2.394-3.73 2.386-3.692 0V6.777A1.86 1.86 0 0 1 6.23 4.974c1.138-.367 2.396.577 2.364 1.768zM11.05 4.9h6.33c2.391-.039 2.394 3.723 0 3.684h-5.964c-.008-1.096.114-2.672-.366-3.684m5.027 13.764-.629-.632-4.029-4.022v-2.606h2.607l4.66 4.654c1.717 1.664-.944 4.323-2.61 2.606Z',
  },
  {
    name: 'Kling',
    viewBox: '0 0 24 24',
    path: 'M21.973 15.22a287 287 0 0 1-2.218-1.758c-.4-.32-.825-.659-1.347-1.073 3.47-4.107 1.171-7.015-.336-8.523-1.883-1.884-4.869-2.44-7.824-1.922-3.49.613-6.526 2.806-8.331 6.02l-.317.562s3.7 2.937 4.357 3.455c-3.27 4.432-1.227 7.086-.223 8.091 1.477 1.477 3.952 2.296 6.207 2.296.62 0 1.256-.054 1.894-.166 3.49-.613 6.527-2.807 8.333-6.02l.317-.563-.507-.398zM5.264 9.508a317 317 0 0 0-1.706-1.355c1.608-2.515 4.11-4.224 6.948-4.722 1.782-.312 3.51-.112 4.96.548-3.776.91-7.148 3.758-8.802 6.645L5.262 9.507zm4.096-.265c2.787-3.17 6.368-4.578 7.995-3.146s.69 5.163-2.099 8.333c-2.787 3.17-6.368 4.577-7.995 3.146-1.627-1.433-.69-5.164 2.099-8.333m4.213 11.476c-1.783.313-3.509.113-4.96-.547 3.776-.91 7.149-3.758 8.801-6.644.548.435.988.785 1.402 1.116.534.427 1.046.835 1.704 1.355-1.608 2.516-4.109 4.225-6.947 4.722z',
  },
  {
    name: 'Seedream',
    viewBox: '0 0 32 32',
    path: 'M5.915 25.44 1 26.702V4.311l4.915 1.263zm23.75 1.31-4.924 1.264V3l4.924 1.254zm-15.952-.627-4.915 1.264v-13.19l4.915 1.263zm3.21-13.883 4.925-1.264v13.19l-4.924-1.264z',
  },
  {
    name: 'Flux',
    viewBox: '0 0 490 345',
    path: 'M349.391 147.163h-52.114l-52.113-73.418L82.594 302.52h52.227l110.341-155.352h52.113L186.935 302.52h52.369l110.087-155.355v73.417l-58.013 81.949v42.597h-30.154l-.001.002h-52.114l.001-.002h-52.439l-.004.006h-52.113l.004-.006H0L245.164 0zM490 345.13h-52.114l-.001-.002h-30.156v-42.44l-58.338-82.106v-73.417z',
  },
  {
    name: 'Sora',
    viewBox: '0 0 24 24',
    path: 'M22.282 9.821a5.99 5.99 0 0 0-.516-4.91 6.05 6.05 0 0 0-6.51-2.9A6.065 6.065 0 0 0 4.981 4.18a5.99 5.99 0 0 0-3.998 2.9 6.05 6.05 0 0 0 .743 7.097 5.98 5.98 0 0 0 .51 4.911 6.05 6.05 0 0 0 6.515 2.9A5.99 5.99 0 0 0 13.26 24a6.06 6.06 0 0 0 5.772-4.206 6 6 0 0 0 3.997-2.9 6.06 6.06 0 0 0-.747-7.073zM13.26 22.43a4.48 4.48 0 0 1-2.876-1.04l.141-.081 4.779-2.758a.8.8 0 0 0 .392-.681v-6.737l2.02 1.168a.07.07 0 0 1 .038.052v5.583a4.504 4.504 0 0 1-4.494 4.494M3.6 18.304a4.47 4.47 0 0 1-.535-3.014l.142.085 4.783 2.759a.77.77 0 0 0 .78 0l5.843-3.369v2.332a.08.08 0 0 1-.033.062L9.74 19.95a4.5 4.5 0 0 1-6.14-1.646M2.34 7.896a4.5 4.5 0 0 1 2.366-1.973V11.6a.77.77 0 0 0 .388.677l5.815 3.354-2.02 1.168a.08.08 0 0 1-.071 0l-4.83-2.786A4.504 4.504 0 0 1 2.34 7.872zm16.597 3.855-5.833-3.387L15.119 7.2a.08.08 0 0 1 .071 0l4.83 2.791a4.494 4.494 0 0 1-.676 8.105v-5.678a.79.79 0 0 0-.407-.667zm2.01-3.023-.141-.085-4.774-2.782a.78.78 0 0 0-.785 0L9.409 9.23V6.897a.07.07 0 0 1 .028-.061l4.83-2.787a4.5 4.5 0 0 1 6.68 4.66zm-12.64 4.135-2.02-1.164a.08.08 0 0 1-.038-.057V6.075a4.5 4.5 0 0 1 7.375-3.453l-.142.08-4.778 2.758a.8.8 0 0 0-.393.681zm1.097-2.365 2.602-1.5 2.607 1.5v2.999l-2.597 1.5-2.607-1.5Z',
  },
  { name: 'Perplexity', Icon: PerplexitySvg },
  { name: 'Kimi', Icon: MoonshotSvg },
  { name: 'DeepSeek', Icon: DeepseekSvg },
  { name: 'MiniMax', Icon: HailuoSvg },
  { name: 'xAI', Icon: XaiSvg },
  { name: 'Qwen', Icon: QwenSvg },
];

const ModelLogosMarquee = ({
  fadeColor = '#050509',
}: {
  fadeColor?: string;
}) => (
  <div className='relative w-full overflow-hidden'>
    <div className='flex w-max items-center gap-x-8 animate-scroll-logos motion-reduce:animate-none'>
      {[false, true].map((isDuplicate) => (
        <React.Fragment key={isDuplicate ? 'dup' : 'main'}>
          {MODEL_LOGOS.map((logo) => (
            <div
              key={`${isDuplicate ? 'dup-' : ''}${logo.name}`}
              className='flex shrink-0 items-center gap-2 pr-8'
              aria-hidden={isDuplicate || undefined}
            >
              {logo.Icon ? (
                <logo.Icon
                  aria-hidden='true'
                  className='h-[18px] w-auto shrink-0 fill-white/50 [&_path]:fill-white/50'
                />
              ) : (
                <svg
                  xmlns='http://www.w3.org/2000/svg'
                  viewBox={logo.viewBox}
                  width={16}
                  height={16}
                  aria-hidden='true'
                  className='h-[18px] w-auto shrink-0 fill-white/50'
                >
                  <path d={logo.path} />
                </svg>
              )}
              <span className='shrink-0 text-base font-normal text-white/50'>
                {logo.name}
              </span>
            </div>
          ))}
        </React.Fragment>
      ))}
    </div>
    <div
      className='pointer-events-none absolute inset-y-0 left-0 w-16'
      style={{
        background: `linear-gradient(to right, ${fadeColor}, transparent)`,
      }}
    />
    <div
      className='pointer-events-none absolute inset-y-0 right-0 w-16'
      style={{
        background: `linear-gradient(to left, ${fadeColor}, transparent)`,
      }}
    />
  </div>
);

export default ModelLogosMarquee;
